export { default } from './EntitiesTitle'
